






// Utilities
import { waitForReadystate } from '@/utils/componentHelpers';
import accounts from '@/mixins/accounts';
import mixins from '@/utils/mixins';
import { get } from 'vuex-pathify';
import { GoToOptions } from 'vuetify/types/services/goto';

export default mixins(accounts).extend({
  name: 'App',

  metaInfo: {
    titleTemplate: '%s Expoleap',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data: () => ({
    duration: 1000,
    offset: 100,
    appOffset: true
  }),
  computed: {
    appLoaded: get<boolean>('app/appLoaded'),
    goToOptions(): GoToOptions {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: 'easeInOutCubic'
      };
    }
  },
  watch: {
    '$route.path'() {
      typeof window !== 'undefined' && window.scrollTo(0, 0);
    }
  },
  async mounted() {
    if (!this.$route.hash) return;

    await this.$nextTick();
    await waitForReadystate();

    if (this.getAppUserInfo) {
      const user = JSON.parse(`${this.getAppUserInfo}`);
      return this.fetchAccount(user.user_id);
    }

    this.$vuetify.goTo(this.$route.hash, this.goToOptions as GoToOptions);
  }
});
